(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24692,598,42227,68425,83421,68429],{

/***/ 47546:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earnings",
      function () {
        return __webpack_require__(92060);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_earnings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/features/earnings/slice.ts + 1 modules
var slice = __webpack_require__(79695);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Pagination.js
var Pagination = __webpack_require__(35266);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/earnings/components/Pagination/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-pagination-next,\n  .ant-pagination-prev {\n    padding: 0px 10px;\n  }\n\n  .ant-pagination-next:hover,\n  .ant-pagination-prev:hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var SPaginationEarnings = (0,styled_components_browser_esm/* default */.ZP)(Pagination/* default */.Z).withConfig({
    componentId: "sc-562c32ff-0"
})(_templateObject(), color/* default.whisper */.Z.whisper, color/* default.primary */.Z.primary);
var itemRender = function(current, type, originalElement) {
    if (type === "prev") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Prev"
        });
    }
    if (type === "next") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Next"
        });
    }
    return originalElement;
};
var EarningsPagination = function(param) {
    var totalRow = param.totalRow, currentPage = param.currentPage;
    var ref = (0,es/* useSelector */.v9)(slice/* earningsSelectors */.Y5), _earnings = ref.earnings, _data = _earnings.data, order = _data.order, sortcol = _data.sortcol, year = _data.year, quarter = _data.quarter, filter = _data.filter, keyword = _data.keyword;
    var dispatch = (0,es/* useDispatch */.I0)();
    var onSelectPageHandler = function(page) {
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            page: page,
            order: order,
            sortcol: sortcol,
            year: year,
            quarter: quarter.toString(),
            companySymbol: keyword || undefined,
            filter: filter
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SPaginationEarnings, {
        current: Number(currentPage),
        defaultPageSize: 50,
        total: totalRow,
        showSizeChanger: false,
        itemRender: itemRender,
        onChange: onSelectPageHandler
    });
};
/* harmony default export */ var components_Pagination = (EarningsPagination);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
;// CONCATENATED MODULE: ./src/features/earnings/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  font-family: var(--bold-font);\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  margin: 0px;\n  margin-bottom: 20px;\n  max-width: 100%;\n  padding: 15px 20px;\n  position: relative;\n  text-overflow: ellipsis;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: 100%;\n  padding-bottom: 40px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 20px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n\n  .ant-modal-content button .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 2.5;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  .ant-select .ant-select-selector {\n    border-radius: 3px;\n  }\n\n  .ant-select .ant-select-selector .ant-select-selection-search button {\n    border-radius: 0 3px 3px 0 !important;\n  }\n  @media screen and (min-width: 721px) {\n    gap: 20px;\n    .sector-search,\n    .symbol-search {\n      width: 300px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  padding-right: 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: var(--regular-font);\n  font-size: 13px;\n  margin: 20px 0px;\n\n  .ant-table-container {\n    border-radius: 3px;\n  }\n  .ant-table-container,\n  th,\n  td {\n    border-color: ",
        " !important;\n  }\n\n  table th,\n  table td {\n    padding: 4px 10px;\n    text-align: right;\n\n    &.symbol {\n      text-align: left;\n    }\n  }\n\n  .symbol {\n    & .ant-table-column-sorters {\n      justify-content: flex-start;\n    }\n  }\n\n  .ant-table-column-sorters {\n    display: flex;\n    justify-content: flex-end;\n    padding: 6px 14px;\n    width: 100%;\n  }\n\n  .ant-table-tbody > tr > td {\n    padding: 4px 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  td {\n    width: 33.33%;\n    padding: 5px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var SHeader = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-d237ed2a-0"
})(styled_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.dimgray */.Z.dimgray);
var SContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-1"
})(_templateObject1());
var SBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-2"
})(_templateObject2(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var SBodyWrapperTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-3"
})(_templateObject3());
var SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-4"
})(_templateObject4());
var Th = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    family: "bold",
    align: "right"
}).withConfig({
    componentId: "sc-d237ed2a-5"
})(_templateObject5());
var TableEarnings = (0,styled_components_browser_esm/* default */.ZP)(Table/* default */.Z).withConfig({
    componentId: "sc-d237ed2a-6"
})(_templateObject6(), color/* default.gainsboro */.Z.gainsboro);
var TableEarningWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-7"
})(_templateObject7());
var TableEarning = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-d237ed2a-8"
})(_templateObject8());
var ModalIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d237ed2a-9"
})(_templateObject9());


// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
;// CONCATENATED MODULE: ./src/features/earnings/components/Table/ModalEarning.tsx






var ModalEarning = function(param) {
    var visible = param.visible, onCancel = param.onCancel, earning = param.earning, customRenderNumber = param.customRenderNumber, EARNINGS_TYPE = param.EARNINGS_TYPE;
    var renderValue = function(text, name) {
        var value = customRenderNumber({
            text: text,
            name: name,
            isNeedBackgroundColor: true
        });
        var style = {};
        var valueText = "";
        if (typeof value === "string") {
            valueText = value;
        } else {
            valueText = value.children;
            style = value.props.style;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
            style: style,
            children: valueText
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        centered: true,
        // @ts-expect-error
        noBorder: true,
        visible: visible,
        onCancel: onCancel,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: "absolute",
                top: -8,
                right: 15
            },
            children: "X"
        }),
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "16px",
            family: "bold",
            padding: "10px 15px",
            style: {
                borderBottom: "solid 1px ".concat(color/* default.gainsboro */.Z.gainsboro)
            },
            children: "Quarterly EPS Recap"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableEarningWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableEarning, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        style: {
                            borderBottom: "solid 1px ".concat(color/* default.gainsboro */.Z.gainsboro)
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Symbol"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/symbol/".concat(earning.symbol),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        family: "bold",
                                        color: color/* default.primary */.Z.primary,
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: earning.symbol
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Consensus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Actual"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: customRenderNumber({
                                    text: earning.consensus.actual,
                                    isNeedBackgroundColor: false,
                                    name: EARNINGS_TYPE.CONSENSUS.ACTUAL
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Estimate"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: customRenderNumber({
                                    text: earning.consensus.estimate,
                                    isNeedBackgroundColor: false,
                                    name: EARNINGS_TYPE.CONSENSUS.ESTIMATE
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        style: {
                            borderBottom: "solid 1px ".concat(color/* default.gainsboro */.Z.gainsboro)
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Surprise"
                                })
                            }),
                            renderValue(earning.consensus.surprise, EARNINGS_TYPE.CONSENSUS.SURPRISE)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Previous Year"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Actual"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: customRenderNumber({
                                    text: earning.prevyear.actual,
                                    isNeedBackgroundColor: false,
                                    name: EARNINGS_TYPE.PREVIOUS_YEAR.ACTUAL
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Previous"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: customRenderNumber({
                                    text: earning.prevyear.previous,
                                    isNeedBackgroundColor: false,
                                    name: EARNINGS_TYPE.PREVIOUS_YEAR.PREVIOUS
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: "Change"
                                })
                            }),
                            renderValue(earning.prevyear.change, EARNINGS_TYPE.PREVIOUS_YEAR.CHANGE)
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Table_ModalEarning = (ModalEarning);

;// CONCATENATED MODULE: ./src/features/earnings/components/Table/index.tsx















var EARNINGS_TYPE = {
    CONSENSUS: {
        ACTUAL: "consensusActual",
        ESTIMATE: "consensusEstimate",
        SURPRISE: "consensusSurprise"
    },
    PREVIOUS_YEAR: {
        ACTUAL: "previousYearActual",
        PREVIOUS: "previousYearPrevious",
        CHANGE: "previousYearChange"
    }
};
var customRenderNumber = function(param) {
    var text = param.text, isNeedBackgroundColor = param.isNeedBackgroundColor, name = param.name;
    if (name === EARNINGS_TYPE.PREVIOUS_YEAR.CHANGE && !parseFloat(text)) {
        return "-";
    }
    if (text === null || text === "-") {
        return "-";
    }
    return isNeedBackgroundColor ? {
        children: "".concat(numeral_default()(text).format("0.00"), "%"),
        props: {
            style: {
                background: text > 0 ? "rgba(144, 232, 151, 0.5)" : "rgba(255, 152, 142, 0.5)"
            }
        }
    } : numeral_default()(text).format("0.00");
};
var tableDataGenerator = function(companyList) {
    if (companyList) {
        return companyList.map(function(item) {
            return (0,_object_spread/* default */.Z)({
                symbol: item.company_name
            }, item.analyst);
        });
    }
    return [];
};
var EarningsTable = function(param) {
    var screenWidth = param.screenWidth;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(null), rowSelected = ref[0], setRowSelected = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(slice/* earningsSelectors */.Y5), _earnings = ref1.earnings, rawData = _earnings.data, isLoading = _earnings.isLoading;
    var company = rawData.company, page = rawData.page, totalrows = rawData.totalrows, keyword = rawData.keyword, year = rawData.year, quarter = rawData.quarter, filter = rawData.filter;
    var data = tableDataGenerator(company);
    var columnHeaderClickHandler = function(pagination, filters, sorter) {
        if (!sorter || !sorter.column) {
            return;
        }
        var order = sorter.order, dataSortCol = sorter.column.dataSortCol;
        var sortMode = // eslint-disable-next-line no-nested-ternary
        order === "ascend" ? "asc" : order === "descend" ? "desc" : "";
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            companySymbol: keyword || undefined,
            order: sortMode,
            sortcol: dataSortCol,
            page: "1",
            year: year,
            quarter: quarter,
            filter: filter
        }));
    };
    var columnSymbolRender = function(text) {
        return {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/symbol/".concat(text),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            as: "a",
                            href: "/symbol/".concat(text),
                            color: color/* default.primary */.Z.primary,
                            "data-cy": "".concat(data_cy/* default.EARNINGS.TABLE_ROW_SYMBOL */.Z.EARNINGS.TABLE_ROW_SYMBOL, "-").concat(text),
                            children: "".concat(text)
                        })
                    }),
                    screenWidth <= 720 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalIconWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            size: "14px",
                            className: "icon-toolbar_next",
                            onClick: function() {
                                return setRowSelected(text);
                            }
                        })
                    }) : null
                ]
            })
        };
    };
    var consensusChildren = function() {
        var children = [
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Actual"
                }),
                dataIndex: [
                    "consensus",
                    "actual"
                ],
                sorter: true,
                dataSortCol: 2,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: false,
                        name: EARNINGS_TYPE.CONSENSUS.ACTUAL
                    });
                }
            },
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Estimate"
                }),
                dataIndex: [
                    "consensus",
                    "estimate"
                ],
                sorter: true,
                dataSortCol: 3,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: false,
                        name: EARNINGS_TYPE.CONSENSUS.ESTIMATE
                    });
                }
            },
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Surprise"
                }),
                dataIndex: [
                    "consensus",
                    "surprise"
                ],
                sorter: true,
                dataSortCol: 4,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: true,
                        name: EARNINGS_TYPE.CONSENSUS.SURPRISE
                    });
                }
            }, 
        ];
        if (screenWidth <= 720) {
            return children.splice(2, 1);
        }
        return children;
    };
    var prevYearChildren = function() {
        var children = [
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Actual"
                }),
                dataIndex: [
                    "prevyear",
                    "actual"
                ],
                sorter: true,
                dataSortCol: 2,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: false,
                        name: EARNINGS_TYPE.PREVIOUS_YEAR.ACTUAL
                    });
                }
            },
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Previous"
                }),
                dataIndex: [
                    "prevyear",
                    "previous"
                ],
                sorter: true,
                dataSortCol: 5,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: false,
                        name: EARNINGS_TYPE.PREVIOUS_YEAR.PREVIOUS
                    });
                }
            },
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                    children: "Change"
                }),
                dataIndex: [
                    "prevyear",
                    "change"
                ],
                sorter: true,
                dataSortCol: 6,
                render: function(text) {
                    return customRenderNumber({
                        text: text,
                        isNeedBackgroundColor: true,
                        name: EARNINGS_TYPE.PREVIOUS_YEAR.CHANGE
                    });
                }
            }, 
        ];
        if (screenWidth <= 720) {
            return children.splice(2, 1);
        }
        return children;
    };
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {}),
            children: [
                {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                        children: "Symbol"
                    }),
                    dataIndex: "symbol",
                    render: columnSymbolRender,
                    dataSortCol: 1,
                    sorter: function(a, b) {
                        return a.symbol.localeCompare(b.symbol);
                    },
                    className: "symbol"
                }, 
            ]
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: "Consensus"
            }),
            children: consensusChildren()
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: "Previous Year"
            }),
            children: prevYearChildren()
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableEarnings, {
                dataSource: data,
                columns: columns,
                pagination: false,
                onChange: columnHeaderClickHandler,
                bordered: true,
                loading: isLoading,
                sortDirections: [
                    "ascend",
                    "descend",
                    "ascend"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Pagination, {
                currentPage: page,
                totalRow: totalrows
            }),
            rowSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_ModalEarning, {
                visible: !!rowSelected,
                onCancel: function() {
                    return setRowSelected(null);
                },
                EARNINGS_TYPE: EARNINGS_TYPE,
                customRenderNumber: customRenderNumber,
                earning: data.find(function(param) {
                    var symbol = param.symbol;
                    return symbol === rowSelected;
                })
            }) : null
        ]
    });
};
/* harmony default export */ var components_Table = (EarningsTable);

;// CONCATENATED MODULE: ./src/features/earnings/components/QuarterNavigation/index.tsx

function QuarterNavigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    QuarterNavigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var NavIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ff6a83a-0"
})(QuarterNavigation_templateObject(), color/* default.gainsboro */.Z.gainsboro);
var QuarterNavigation = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(slice/* earningsSelectors */.Y5), data = ref.earnings.data;
    var quarter = data.quarter, year = data.year, prevPeriod = data.prev_earnings_period, nextPeriod = data.next_earnings_period, order = data.order, page = data.page, sortcol = data.sortcol, keyword = data.keyword, filter = data.filter;
    var getData = function(q, y) {
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            year: y,
            quarter: q,
            order: order,
            page: page,
            sortcol: sortcol,
            companySymbol: keyword || undefined,
            filter: filter
        }));
    };
    var prevQuarterHandler = function() {
        var prevQuarter = prevPeriod.quarter, prevYear = prevPeriod.year;
        getData(prevQuarter, prevYear);
    };
    var nextQuarterHandler = function() {
        var nextQuarter = nextPeriod.quarter, nextYear = nextPeriod.year;
        if (nextQuarter) {
            getData(nextQuarter, nextYear);
            return;
        }
        getData(quarter, year);
    };
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        ml: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavIconWrap, {
                onClick: prevQuarterHandler,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    size: "14px",
                    className: "icon-toolbar_prev"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                width: "70px",
                size: "14px",
                align: "center",
                children: [
                    "Q".concat(quarter || " ..."),
                    " ",
                    year || " ..."
                ]
            }),
            nextPeriod && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavIconWrap, {
                onClick: nextQuarterHandler,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    size: "14px",
                    className: "icon-toolbar_next"
                })
            })
        ]
    }));
};
/* harmony default export */ var components_QuarterNavigation = (QuarterNavigation);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
;// CONCATENATED MODULE: ./src/features/earnings/components/SectorSearch/index.tsx






var SelectOption = Select/* default.Option */.Z.Option, OptGroup = Select/* default.OptGroup */.Z.OptGroup;
var SectorSearch = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), filteredSectors = ref[0], setFilteredSectors = ref[1];
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(slice/* earningsSelectors */.Y5), data = ref2.screenerUniverse.data, _earnings = ref2.earnings, _data = _earnings.data, order = _data.order, sortcol = _data.sortcol, year = _data.year, quarter = _data.quarter, keyword = _data.keyword;
    var index = data.index, sectors = data.sectors;
    var filterSector = function(query) {
        return sectors.filter(function(el) {
            return JSON.stringify(el.subsector).toLowerCase().includes(query);
        });
    };
    var onTypeHandler = function(e) {
        var query = e.target.value;
        if (query.length !== 0) {
            var newFilteredSectors = filterSector(query);
            setFilteredSectors(newFilteredSectors);
        } else {
            setFilteredSectors([]);
        }
    };
    var dropdownSectorSearch = function(dropdownItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    // @ts-expect-error
                    mx: "8px",
                    width: "calc(100% - 16px)",
                    id: "input-sector",
                    onChange: onTypeHandler
                }),
                dropdownItem
            ]
        });
    };
    var getData = function() {
        var filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            order: order || "asc",
            sortcol: sortcol,
            page: "1",
            quarter: quarter.toString(),
            year: year,
            companySymbol: keyword || undefined,
            filter: filter
        }));
    };
    var onSelectHandler = function(name, attributes) {
        var key = attributes.key;
        if (key === "IHSG") {
            getData();
            setVisible(false);
            return;
        }
        getData(key);
        setVisible(false);
    };
    var recomposeSectors = function() {
        if (filteredSectors.length) {
            return filteredSectors === null || filteredSectors === void 0 ? void 0 : filteredSectors.map(function(param) {
                var name = param.name, idSect = param.id, subsector = param.subsector;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                            value: name,
                            children: name
                        }, idSect),
                        subsector.map(function(param) {
                            var idSub = param.id, nameSub = param.name;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                value: nameSub,
                                style: {
                                    paddingLeft: "32px",
                                    fontFamily: "ProximaNovaRg"
                                },
                                children: nameSub
                            }, idSub);
                        })
                    ]
                });
            });
        }
        return sectors === null || sectors === void 0 ? void 0 : sectors.map(function(param) {
            var name = param.name, idSect = param.id, subsector = param.subsector;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                        value: name,
                        children: name
                    }, idSect),
                    subsector.map(function(param) {
                        var idSub = param.id, nameSub = param.name;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                            value: nameSub,
                            style: {
                                paddingLeft: "32px",
                                fontFamily: "ProximaNovaRg"
                            },
                            children: nameSub
                        }, idSub);
                    })
                ]
            });
        });
    };
    var handleClick = function(e) {
        e.stopPropagation();
        var mainLayout = document.querySelector("#main-container");
        var target = e.target;
        var targetId = target.id;
        var targetClassname = target.className;
        if (!visible) {
            if (targetClassname === "ant-select-selection-item" && mainLayout.contains(target)) {
                setVisible(true);
                return;
            }
        }
        if (visible) {
            if (targetId !== "input-sector") {
                setVisible(false);
            }
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClick);
        return function() {
            document.removeEventListener("click", handleClick);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
        className: "sector-search",
        defaultValue: "IHSG",
        // @ts-expect-error
        name: "stockUniverse",
        width: "50%",
        dropdownRender: dropdownSectorSearch,
        showArrow: true,
        onSelect: onSelectHandler,
        open: visible,
        onFocus: function() {
            return setVisible(true);
        },
        children: [
            index === null || index === void 0 ? void 0 : index.map(function(param) {
                var name = param.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                    value: name,
                    children: name
                }, name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptGroup, {
                label: "Sectors",
                children: recomposeSectors()
            })
        ]
    });
};
/* harmony default export */ var components_SectorSearch = (SectorSearch);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/features/earnings/components/SymbolSearch/index.tsx










var CompanyTag = Tag/* default.Tag */.Z.Tag;
var generateSymbolSearchHandler = function() {
    var company = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return company.map(function(param) {
        var name = param.name, desc = param.desc;
        return {
            value: name,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTag, {
                        size: "xs",
                        type: "grey",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        weight: "400px",
                        size: "14px",
                        ml: "8px",
                        children: desc
                    })
                ]
            })
        };
    });
};
var SymbolSearch = function() {
    var ref = (0,react.useState)(""), inputSymbol = ref[0], setInputSymbol = ref[1];
    var delayTimer = (0,react.useRef)(undefined);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(slice/* earningsSelectors */.Y5), suggestedCompanies = ref2.suggestedCompanies, _earnings = ref2.earnings, _data = _earnings.data, order = _data.order, sortcol = _data.sortcol, year = _data.year, quarter = _data.quarter, filter = _data.filter;
    var company = suggestedCompanies.data.company;
    var options = generateSymbolSearchHandler(company);
    var getData = function() {
        var symbol = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            companySymbol: symbol,
            page: "1",
            order: order || "asc",
            sortcol: sortcol,
            quarter: quarter,
            year: year,
            filter: filter
        }));
    };
    var onClickHandler = function(symbol) {
        getData(symbol);
    };
    var onTypeHandler = function(e) {
        var value = e.target.value;
        if (value.length === 0) {
            dispatch(slice/* default.actions.clearSuggestionCompany */.ZP.actions.clearSuggestionCompany());
        }
        setInputSymbol(value);
    };
    // Could be on press enter or on click search
    var onEnterSearch = function(e) {
        var inputValue = e;
        if (typeof e !== "string") {
            inputValue = e.target.value;
        }
        getData(inputValue || undefined);
    };
    (0,react.useEffect)(function() {
        if (!loaded) {
            setLoaded(true);
        }
        return function() {
            setLoaded(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (loaded) {
            if (inputSymbol.length !== 0) {
                clearTimeout(delayTimer.current);
                delayTimer.current = setTimeout(function() {
                    dispatch(slice/* earningsEffects.getsuggestedCompanies */.nO.getsuggestedCompanies({
                        query: inputSymbol
                    }));
                }, 350);
            }
        }
    }, [
        inputSymbol,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (loaded) {
            var searchButton = document === null || document === void 0 ? void 0 : document.querySelector(".sector-search.symbol-search button.ant-input-search-button");
            if (searchButton) {
                searchButton.setAttribute("data-cy", data_cy/* default.EARNINGS.SEARCH_SYMBOL_BUTTON */.Z.EARNINGS.SEARCH_SYMBOL_BUTTON);
            }
        }
    }, [
        loaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        id: "symbol-earnings",
        className: "sector-search symbol-search",
        options: options,
        onSelect: onClickHandler,
        placeholder: "Symbol",
        width: "50%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default.Search */.Z.Search, {
            value: inputSymbol,
            onChange: onTypeHandler,
            onPressEnter: onEnterSearch,
            onSearch: onEnterSearch,
            "data-cy": data_cy/* default.EARNINGS.SEARCH_SYMBOL_INPUT */.Z.EARNINGS.SEARCH_SYMBOL_INPUT
        })
    });
};
/* harmony default export */ var components_SymbolSearch = (SymbolSearch);

;// CONCATENATED MODULE: ./src/features/earnings/index.tsx









var Earnings = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(0), screenWidth = ref[0], setScreenWidth = ref[1];
    (0,react.useEffect)(function() {
        dispatch(slice/* earningsEffects.getScreenerUniverse */.nO.getScreenerUniverse());
        dispatch(slice/* earningsEffects.getEarnings */.nO.getEarnings({
            order: "desc",
            page: "1",
            sortcol: "4"
        }));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var getDimension = function() {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", getDimension);
        getDimension();
        return function() {
            return window.removeEventListener("resize", getDimension);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SContainer, {
        id: "fullbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SHeader, {
                id: "genhead",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Quarterly EPS Recap"
                    }),
                    screenWidth <= 720 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuarterNavigation, {}) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SBodyWrapperTop, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectorSearch, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SymbolSearch, {})
                                ]
                            }),
                            screenWidth > 720 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuarterNavigation, {}) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Table, {
                        screenWidth: screenWidth
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var earnings = (Earnings);

// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Page.tsx
var Page = __webpack_require__(16943);
;// CONCATENATED MODULE: ./pages/earnings.tsx

__webpack_require__(14473);







var earnings_Earnings = function() {
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Earnings Recap"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                        loaded: isLoaded
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                        feature: "EARNINGS",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(earnings, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_earnings = (earnings_Earnings);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c038202d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 15807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  cursor : pointer;\n  \n  ::before {\n    content: '",
        "';\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 7%;\n    left: 7%;\n    color: ",
        ";\n    background: ",
        ";\n    border-radius: 50%;\n    min-width: 18px;\n    font-size: 12px;\n    font-weight: bold;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "icomoon";\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "auto",
        padding: props.padding || "0px",
        newItem: props.newItem || 0,
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-793d8880-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var newItem = param.newItem;
    return newItem || "";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Iconmoon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.attrs */ .ZP.p.attrs(function(props) {
    return {
        size: props.size || "16px",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray,
        isActive: props.isActive || false,
        hoverColor: props.hoverColor || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
        weight: props.weight || "normal"
    };
}).withConfig({
    componentId: "sc-793d8880-1"
})(_templateObject1(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(props) {
    return !props.isActive ? props.color : _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary;
}, function(props) {
    return props.hoverColor;
});

/* harmony default export */ __webpack_exports__["Z"] = (Iconmoon);


/***/ }),

/***/ 54325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    height: 35px;\n    border: 1px solid ",
        ";\n    @media ",
        " {\n      width: 300px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    outline-color: transparent;\n    box-shadow: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border-color: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    withdraw: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].laptop */ .Z.laptop)
};
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "auto",
        margin: props.margin || "0",
        padding: props.padding || "5px",
        round: props.round || true,
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var round = param.round;
    return round ? "2px" : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var typeKey = param.type;
    return type[typeKey];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
Input.TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "100%",
        margin: props.margin || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-1"
})(_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 35266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56673);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next {\n      border: 1px solid ",
        ";\n      a {\n        padding: 0 10px;\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      margin-right: 0;\n      border: 1px solid ",
        ";\n    }\n\n    .ant-pagination-item {\n      margin-right: 0;\n      border-radius: 0;\n      border-color: ",
        ";\n\n      a {\n        color: ",
        ";\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .ant-pagination-item-active {\n      a {\n        color: ",
        ";\n        font-weight: 600;\n      }\n      background: ",
        ";\n    }\n\n    .ant-pagination-prev:focus .ant-pagination-item-link,\n    .ant-pagination-next:focus .ant-pagination-item-link,\n    .ant-pagination-prev:hover .ant-pagination-item-link,\n    .ant-pagination-next:hover .ant-pagination-item-link {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro)
};
var Pagination = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-31bb62cf-0"
})(_templateObject2(), function(props) {
    return type[props.type];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    // Some API chat with 'blokir' message and 'FORBIDDEN' error_type should show alert
    // remove this block whenever BE possible to change error_type from 'FORBIDDEN'
    if (message.includes("blokir")) {
        var errMessageDefault = message;
        (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        return;
    }
    /// ///////////////////////////////////////////////////
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault1 = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(errorType, message) {
    if (errorType === "INVALID_RECAPTCHA") {
        return;
    }
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14229);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 22;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    ;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return refreshTokenPromise();
                case 14:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](11);
                    throw new Error("Failed Refresh Token");
                case 21:
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        throw new Error("Failed API call after success refresh token");
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 22:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 30;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 25:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 28;
                    return apiInstance.request(axiosError.config);
                case 28:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 30:
                    if (refreshTokenConfig.refreshingTokenStatus === "failed") {
                        refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, index) {
                                var reject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            reject = param.reject;
                                            reject(axiosError);
                                            if (index === refreshTokenConfig.refreshAndRetryQueue.length - 1) {
                                                refreshTokenConfig.refreshAndRetryQueue = [];
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_, index) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    }
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t1 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t1));
                case 37:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, errors, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "info",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        errors = (data === null || data === void 0 ? void 0 : data.errors) || [];
                        // Some error message is unparsed in `message`
                        if (!errorType) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 26:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "m6": function() { return /* binding */ TRADING_VIEW_ASSET_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var TRADING_VIEW_ASSET_PREFIX = process.env.NEXT_PUBLIC_TV_ASSET || "https://stockbit.com/tradingview/charting_library/";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_RECAPTCHA: "INVALID_RECAPTCHA",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Report has been delivered",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 79695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "nO": function() { return /* binding */ earningsEffects; },
  "Y5": function() { return /* binding */ earningsSelectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/earnings.ts


var request = (0,requestExodus/* default */.Z)();
var GET_EARNINGS = "".concat(api/* API_EXODUS_URL */.q7, "/earnings");
var getEarnings = function(param) {
    var page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
    return request.get(GET_EARNINGS, {
        params: {
            filter: filter,
            search: companySymbol,
            quarter: quarter,
            year: year,
            sort_column: sortcol,
            order: order,
            page: page
        }
    });
};
/* harmony default export */ var earnings = (getEarnings);

// EXTERNAL MODULE: ./src/lib/api/screener.ts
var screener = __webpack_require__(70735);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
;// CONCATENATED MODULE: ./src/features/earnings/slice.ts








var CONTEXT = "@feature/earnings";
var actionType = {
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_EARNINGS: "".concat(CONTEXT, "/GET_EARNINGS"),
    GET_SUGGESTED_COMPANY: "".concat(CONTEXT, "/GET_SUGGESTED_COMPANY")
};
var initialState = {
    screenerUniverse: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    earings: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    suggestedCompanies: {
        data: {},
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var earningsState = function(state) {
    return state.earnings;
};
var earningsSelectors = (0,es/* createSelector */.P1)(earningsState, function(calendar) {
    return {
        screenerUniverse: calendar.screenerUniverse,
        earnings: calendar.earings,
        suggestedCompanies: calendar.suggestedCompanies
    };
});
var reducers = {
    clearSuggestionCompany: function(state) {
        state.suggestedCompanies.data.company = [];
    }
};
var earningsEffects = {
    getScreenerUniverse: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SCREENER_UNIVERSE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return screener/* default.getScreenerUniverse */.Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEarnings: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EARNINGS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var page, order, sortcol, year, quarter, companySymbol, filter, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return earnings({
                            page: page,
                            order: order,
                            sortcol: sortcol,
                            year: year,
                            quarter: quarter,
                            companySymbol: companySymbol,
                            filter: filter
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get earnings data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            filter: filter
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getsuggestedCompanies: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SUGGESTED_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var query, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = param.query;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(query);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get suggested companies is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducer = function(builder) {
    builder.addCase(earningsEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.screenerUniverse.error = error;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(earningsEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.error = action.payload.error;
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getEarnings.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error, filter = _payload.filter;
        if (error) {
            state.earings.error = error;
        } else {
            state.earings.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                filter: filter
            });
            state.earings.message = message;
        }
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getEarnings.pending, function(state) {
        state.earings.isLoading = true;
    }).addCase(earningsEffects.getEarnings.rejected, function(state, action) {
        state.earings.error = action.payload.error;
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.suggestedCompanies.error = error;
        } else {
            state.suggestedCompanies.data = data;
            state.suggestedCompanies.message = message;
        }
        state.suggestedCompanies.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.pending, function(state) {
        state.suggestedCompanies.isLoading = true;
    }).addCase(earningsEffects.getsuggestedCompanies.rejected, function(state, action) {
        state.suggestedCompanies.error = action.payload.error;
        state.suggestedCompanies.isLoading = false;
    });
};
var earningsSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "earnings",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (earningsSlice);


/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ AVATAR_SIZE; },
/* harmony export */   "Rm": function() { return /* binding */ ONBOARDING_MAX_STEP; },
/* harmony export */   "Wo": function() { return /* binding */ ONBOARDING_REQUEST_FILTER; }
/* harmony export */ });
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};



/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};


/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_usePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31837);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75850);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67857);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35921);






function PaywallWrapper(param) {
    var children = param.children, feature = param.feature, isFlexible = param.isFlexible, isWidget = param.isWidget;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isReady = ref[0], setReady = ref[1];
    var ref1 = (0,_store_usePage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        featureKey: feature
    }), isPro = ref1.isPro, isLoading = ref1.isLoading, isRenewal = ref1.isRenewal;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReady(true);
    }, []);
    if (isLoading || !isReady) {
        return null;
    }
    if (isPro) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PaywallPageWrapper */ .qh, {
        isFlexible: isFlexible,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            source: _analytics__WEBPACK_IMPORTED_MODULE_4__/* .PageAnalytics */ .oF[feature],
            isRenewal: isRenewal,
            isWidget: isWidget,
            height: "272px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWrapper);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp10 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 31837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92182);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5072);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11298);





function usePage(param) {
    var featureKey = param.featureKey, _pauseCounter = param.pauseCounter, pauseCounter = _pauseCounter === void 0 ? false : _pauseCounter;
    var ref = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(state) {
        return {
            isPro: state.page.isPro,
            isLoading: state.page.isLoading,
            isRenewal: state.page.isRenewal,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isPro = ref.isPro, isLoading = ref.isLoading, isRenewal = ref.isRenewal, getStatus = ref.getStatus, addCounter = ref.addCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var KEY = featureKey.toUpperCase();
        var featureName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .PaywallFeatureEnum */ .qU[KEY];
        if (!featureName) return;
        if (!pauseCounter) addCounter({
            feature: featureName
        });
        getStatus({
            key: _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionEnum.page */ .P.page,
            feature: featureName
        });
    }, [
        featureKey,
        pauseCounter
    ]);
    return {
        isPro: isPro,
        isLoading: isLoading,
        isRenewal: isRenewal
    };
};


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 21455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TradingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TradingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    tradingStore: null
});
/* harmony default export */ __webpack_exports__["Z"] = (TradingContext);


/***/ }),

/***/ 207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/transaction/store.ts



var initialState = {
    openModal: "",
    symbol: null,
    orderType: null,
    formType: null,
    openFromWidget: false
};
var tradingStore = function() {
    return (0,esm/* default */.ZP)(function(set) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
            setModal: function(modal, payload) {
                set((0,_object_spread/* default */.Z)({
                    openModal: modal
                }, payload));
            },
            resetModal: function() {
                set(initialState);
            },
            setSymbol: function(symbol) {
                set({
                    symbol: symbol
                });
            },
            setOrderType: function(type) {
                set({
                    orderType: type
                });
            },
            setFormType: function(type) {
                set({
                    formType: type
                });
            },
            setOpenFromWidget: function(open) {
                set({
                    openFromWidget: open
                });
            },
            setAutoOrderId: function(autoOrderId) {
                set({
                    autoOrderId: autoOrderId
                });
            }
        });
    });
};
/* harmony default export */ var store = (tradingStore);

// EXTERNAL MODULE: ./src/features/transaction/context.tsx
var context = __webpack_require__(21455);
;// CONCATENATED MODULE: ./src/features/transaction/provider.tsx




var TradingContextProvider = function(param) {
    var children = param.children;
    var formValuesContext = (0,react.useMemo)(function() {
        return {
            tradingStore: store()
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: formValuesContext,
        children: children
    });
};
/* harmony default export */ var provider = (TradingContextProvider);


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1624a33f-0"
})(_templateObject(), color/* default.primary */.Z.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ 







/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "14px",
                className: "icon-toolbar_check",
                color: color/* default.light */.Z.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
    return null;
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 53120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/features/onboarding/constants.ts
var constants = __webpack_require__(60602);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= constants/* ONBOARDING_MAX_STEP */.Rm) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        if (!isUserLogin) {
            return;
        }
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2,
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var styled = __webpack_require__(92589);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 










// Local Components








// import webSocketSlice from 'global/WebSocketV2/slice';

// local redux slice


var HeaderWeb = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(50011), __webpack_require__.e(48713)]).then(__webpack_require__.bind(__webpack_require__, 48713));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48713)
            ];
        }
    },
    ssr: false
});
var HeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(12127)]).then(__webpack_require__.bind(__webpack_require__, 12127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12127)
            ];
        }
    },
    ssr: false
});
var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(35851), __webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(6581), __webpack_require__.e(57437)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var OnBoarding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(29306), __webpack_require__.e(7475), __webpack_require__.e(54392), __webpack_require__.e(24826), __webpack_require__.e(91086)]).then(__webpack_require__.bind(__webpack_require__, 91086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91086)
            ];
        }
    },
    ssr: false
});
var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(70735), __webpack_require__.e(35851), __webpack_require__.e(67555), __webpack_require__.e(45580), __webpack_require__.e(98294), __webpack_require__.e(48761), __webpack_require__.e(76219), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(36902), __webpack_require__.e(91727), __webpack_require__.e(79624), __webpack_require__.e(26705), __webpack_require__.e(48308), __webpack_require__.e(99596), __webpack_require__.e(33689), __webpack_require__.e(70536), __webpack_require__.e(12104), __webpack_require__.e(38624), __webpack_require__.e(18027), __webpack_require__.e(45788)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(42298), __webpack_require__.e(61980), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(38305), __webpack_require__.e(62366), __webpack_require__.e(89409)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(70735), __webpack_require__.e(35851), __webpack_require__.e(67555), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(48308), __webpack_require__.e(68106), __webpack_require__.e(20242), __webpack_require__.e(83474), __webpack_require__.e(31943)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(35851), __webpack_require__.e(45580), __webpack_require__.e(1013), __webpack_require__.e(33543), __webpack_require__.e(75413), __webpack_require__.e(74673), __webpack_require__.e(36902), __webpack_require__.e(33689), __webpack_require__.e(61442), __webpack_require__.e(88115), __webpack_require__.e(59795), __webpack_require__.e(63878)]).then(__webpack_require__.bind(__webpack_require__, 9159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9159)
            ];
        }
    },
    ssr: false
});
var ModalBonds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(45580), __webpack_require__.e(98294), __webpack_require__.e(61980), __webpack_require__.e(48761), __webpack_require__.e(36385), __webpack_require__.e(69733), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(91727), __webpack_require__.e(29184), __webpack_require__.e(70536), __webpack_require__.e(35087)]).then(__webpack_require__.bind(__webpack_require__, 14426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14426)
            ];
        }
    },
    ssr: false
});
var ModalUnavailable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(12438)]).then(__webpack_require__.bind(__webpack_require__, 15994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15994)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(92093)]).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var MultiPortoModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(98294), __webpack_require__.e(68606), __webpack_require__.e(44975)]).then(__webpack_require__.bind(__webpack_require__, 44975));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44975)
            ];
        }
    },
    ssr: false
});
var StreamErrorModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(61980), __webpack_require__.e(5633), __webpack_require__.e(38305), __webpack_require__.e(40728), __webpack_require__.e(29901)]).then(__webpack_require__.bind(__webpack_require__, 91011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91011)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(66158)]).then(__webpack_require__.bind(__webpack_require__, 44992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44992)
            ];
        }
    },
    ssr: false
});
function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            fetchChatUnreadCount: s.fetchUnreadCount,
            isChatUnreadCountReset: s.isReset
        };
    }), fetchChatUnreadCount = ref.fetchChatUnreadCount, isChatUnreadCountReset = ref.isChatUnreadCountReset;
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref1 = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref1.isSideWidgetOpen, isHeaderMinimized = ref1.isHeaderMinimized, isMarketOpen = ref1.isMarketOpen;
    // Custom hooks
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)(isLoggedIn);
    hooks_useChatListenerWsSocialV2(isLoggedIn);
    // Reactive variable
    var isShowOnboarding = onboardingProgress < constants/* ONBOARDING_MAX_STEP */.Rm;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    (0,react.useEffect)(function() {
        if (!isLoggedIn) {
            return;
        }
        // During route changes or reload:
        // re-fetch unread chat if state is haven't reset
        // or clear chat data if state have reset
        // if (!isChatUnreadCountReset) {
        //   fetchChatUnreadCount();
        // } else {
        //   dispatch(webSocketSlice.actions.clearChat());
        // }
        fetchChatUnreadCount();
        fetchCommunityInfo();
        dispatch(slice/* effects.getNotifications */.Sz.getNotifications());
    }, [
        isLoggedIn
    ]);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WrapperMainContent */.UI, {
                            isSideWidgetOpen: isSideWidgetOpen,
                            isMarketOpen: isMarketOpen,
                            children: [
                                breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWeb, {
                                    isSideWidgetOpen: isSideWidgetOpen,
                                    isMarketOpen: isMarketOpen,
                                    isHeaderMinimized: isHeaderMinimized
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    background: background,
                                    isSideWidgetOpen: isSideWidgetOpen
                                }, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* default */.ZP, {
                                        id: "main-container",
                                        isFlexibleWidth: isFlexibleWidth,
                                        maxWidth: maxWidth,
                                        isSideWidgetOpen: isSideWidgetOpen,
                                        fullPage: fullPage,
                                        isMarketOpen: isMarketOpen,
                                        children: children
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiPortoModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamErrorModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {})
            ]
        })
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "UI": function() { return /* binding */ WrapperMainContent; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    &:has(#academy-iframe) {\n      position: absolute !important;\n      left: 0;\n      padding-bottom: 0;\n      width: 100% !important;\n      max-width: ",
        ";\n      margin: ",
        ";\n    }\n  }\n\n  @media screen and (min-width: 1500px) {\n    margin: 100px auto 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "330px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "35px";
var SIDE_WIDGET_OPENED_WIDTH = "365px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-98894054-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), device.tablet, props.isMarketOpen ? "calc(100% - 60px)" : "calc(100% - 100px)");
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "unset";
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px) !important";
        }
        return "calc(100% - 365px) !important";
    }();
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && "auto !important";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-1"
})(_templateObject2(), function(props) {
    return props.background ? props.background : "transparent";
});
var WrapperMainContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-2"
})(_templateObject3(), function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "calc(100% - ".concat(SIDE_WIDGET_TOOLBAR_WIDTH, ") ");
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px)";
        }
        return "calc(100% - 365px)";
    }();
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2497);
/* harmony import */ var global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77667);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89790);





var PRICE_ALERT_KEY = "price-alert";
function useNotificationListener() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var unread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.unread;
    });
    var setUnread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.setUnread;
    });
    var notification = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* .notifWsSelector */ .i9);
    var notificationListener = function() {
        var notif = notification[notification.length - 1];
        // Update unread notification
        setUnread(unread + 1);
        var onClose = function() {
            return dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.resetNotification */ .ZP.actions.resetNotification());
        };
        // Show notification on left bottom side
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0,global_Notification__WEBPACK_IMPORTED_MODULE_3__/* .showGeneralNotification */ .uw)(notif, onClose);
    };
    var getPriceAlertFromLocalStorage = function() {
        var alertRaw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PRICE_ALERT_KEY);
        if (alertRaw) {
            try {
                return JSON.parse(alertRaw);
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        if ((notification === null || notification === void 0 ? void 0 : notification.length) > 0) {
            notificationListener();
        }
    }, [
        notification === null || notification === void 0 ? void 0 : notification.length,
        isUserLogin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        var alert = getPriceAlertFromLocalStorage();
        if (alert) {
            dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setAlert */ .ZP.actions.setAlert(alert));
        }
    }, [
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotificationListener);


/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14229);




function useProfileData() {
    // get data from reducer
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // get data from profile
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .selectors */ .wl), dataProfile = ref.data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // check if profile data is available
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (parsedCookie) {
            var token = parsedCookie.accessToken.token;
            // check if there's token but empty data profile
            if (token && !dataProfile.id) {
                var userAccess = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess();
                // @ts-ignore
                var username = userAccess.username;
                // get user data profile
                // @ts-ignore
                dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
            }
        }
    }, [
        dispatch,
        dataProfile
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useProfileData);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14229);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ }),

/***/ 70735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var screenerURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/screener");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getScreenerCustom = function() {
    return request.get("".concat(screenerURL, "/templates"));
};
var getScreenerMetrics = function() {
    return request.get("".concat(screenerURL, "/preset"));
};
var getLoadPresetScreener = function(id, type) {
    var queryString = type ? "?type=".concat(type) : "";
    return request.get("".concat(screenerURL, "/templates/").concat(id).concat(queryString));
};
var getScreenerUniverse = function() {
    return request.get("".concat(screenerURL, "/universe"));
};
var postScreenerListResult = function(data) {
    return request.post("".concat(screenerURL, "/templates"), data);
};
var getScreenerFavorites = function() {
    return request.get("".concat(screenerURL, "/favorites"));
};
var addScreenerFavorite = function(screenerid, type) {
    return request.post("".concat(screenerURL, "/favorites"), {
        screenerid: screenerid,
        type: type
    });
};
var removeScreenerFavorite = function(screenerid, type) {
    return request.delete("".concat(screenerURL, "/favorites/").concat(screenerid, "?type=").concat(type));
};
var getScreenerFinancial = function() {
    return request.get("".concat(screenerURL, "/metric"));
};
var removeScreenerCustom = function(screenerID) {
    return request.delete("".concat(screenerURL, "/templates/").concat(screenerID));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getScreenerCustom: getScreenerCustom,
    getScreenerMetrics: getScreenerMetrics,
    getLoadPresetScreener: getLoadPresetScreener,
    getScreenerUniverse: getScreenerUniverse,
    postScreenerListResult: postScreenerListResult,
    getScreenerFavorites: getScreenerFavorites,
    addScreenerFavorite: addScreenerFavorite,
    removeScreenerFavorite: removeScreenerFavorite,
    getScreenerFinancial: getScreenerFinancial,
    removeScreenerCustom: removeScreenerCustom
});


/***/ }),

/***/ 89790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotificationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var lib_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99368);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);









var useNotificationData = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return {
        tab: "notification",
        isPopupOpen: false,
        isConvoOpen: false,
        isReading: false,
        isLoading: false,
        isLoadingPrevious: false,
        contents: {
            notification: {
                list: [],
                lastId: null
            },
            mention: {
                list: [],
                lastId: null
            },
            report: {
                list: [],
                lastId: null
            },
            tipping: {
                list: [],
                lastId: null
            }
        },
        unread: 0,
        // UI Reducers
        changeTab: function changeTab(tab) {
            set(function(draft) {
                draft.tab = tab;
            });
        },
        togglePopup: function togglePopup() {
            set(function(draft) {
                draft.isPopupOpen = !draft.isPopupOpen;
            });
        },
        closePopup: function closePopup() {
            set(function(draft) {
                draft.isPopupOpen = false;
            });
        },
        setConvoOpen: function setConvoOpen(id) {
            var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            set(function(draft) {
                draft.isConvoOpen = isOpen;
                draft.convoId = id;
            });
        },
        closeConvo: function closeConvo() {
            set(function(draft) {
                draft.isConvoOpen = false;
                draft.convoId = undefined;
            });
        },
        setUnread: function setUnread(count) {
            set(function(draft) {
                draft.unread = count;
            });
        },
        getNotification: // Asynchronous actions
        function getNotification1(tab) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = result;
                                draft.isLoading = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isLoading = false;
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        getPrevNotification: function getPrevNotification(tab, lastId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // if previous
                            set(function(draft) {
                                draft.isLoadingPrevious = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes, 25, lastId);
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(draft.contents[tab].list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result));
                                draft.isLoadingPrevious = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getUnreadCount: function getUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getUnreadNotificationNumber */ .O7)();
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = result.unread;
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 14:
                            throw new Error("failed to read notification");
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        markNotifAsRead: function markNotifAsRead() {
            var tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "notification";
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                                draft.isReading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .markAsRead */ .zJ)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 15;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = 0;
                                    draft.isReading = false;
                                    draft.contents[tab].list = draft.contents[tab].list.map(function(item) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                            is_read: true
                                        });
                                    });
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 15:
                            throw new Error("failed to read notification");
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isReading = false;
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        }
    };
}));


/***/ }),

/***/ 76260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: ""
};
var tradingStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingStore);


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
var isLoggedIn = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, setCharAt, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 




/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
/**
 * @deprecated - do not use for user input manipulation
 * @param {} str
 * @param {*} match
 * @param {*} replacement
 * @returns str
 */ function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary;
    if (Number(number) < 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        ;
        return constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 52523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.4/static/remoteEntry.js?");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,46819,88069,7648,25935,51225,80129,80737,40142,77549,50299,92961,91036,54253,54005,33070,58928,92077,79931,55329,44912,81273,21671,74768,12786,77284,74673,49774,92888,40179], function() { return __webpack_exec__(47546); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);